import React from 'react';
import { Nav } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SidebarMenuProps } from './SidebarMenu.types';
import styles from './SidebarMenu.module.scss';

/**
 * Item-driven sidebar main menu shared by the Dashboard and Event layouts. Renders one
 * NavLink per item with consistent active/hover styling, so both pages look and behave
 * identically. Each layout supplies its own `items` array (including any role gating).
 */
export default function SidebarMenu({ items }: SidebarMenuProps): React.ReactElement {
    return (
        <Nav className="flex-column">
            {items.map((item) => (
                <Nav.Item key={item.to}>
                    <NavLink
                        to={item.to}
                        end={item.end}
                        className={({ isActive }) =>
                            `nav-link ${styles.menuButton} ${isActive ? 'active' : ''}`
                        }
                    >
                        <FontAwesomeIcon icon={item.icon} className="me-2" />
                        {item.label}
                    </NavLink>
                </Nav.Item>
            ))}
        </Nav>
    );
}
